const PERMISSION_KEY= "core:api_key_credentials";
const PAGE_URL = {
    API_KEY_CREDENTIALS_PAGE: "/admin/core/api-key-credentials"
}

export {PERMISSION_KEY, PAGE_URL}

